export const PaySectionTool = {
    path: '/pay_section_tools',
    name: 'pay_section_tools',
    component: () => import('@/views/Tools/PaySectionToolPage.vue'),
    children: [
        {
            path: '/pay_section_tools/add',
            name: 'pay_section_tools.add',
            component: () => import('@/views/PaySection/Form/PaySectionForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/pay_section_tools/edit/:id',
            name: 'pay_section_tools.edit',
            component: () => import('@/views/PaySection/Form/PaySectionForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/pay_section_tools/delete/:id',
            name: 'pay_section_tools.delete',
            component: () => import('@/views/PaySection/Form/PaySectionForm.vue'),
            props: {deleteAction: true}
        },
    ]
}

export const OccupationPaySectionTool = {
    path: '/assigned_pay_section_tools',
    name: 'assigned_pay_section_tools',
    component: () => import('@/views/Tools/AssignedPaySectionToolPage.vue'),
}


export const IrgTool = {
    path: '/irg_tools',
    name: 'irg_tools',
    component: () => import('@/views/Tools/IrgToolPage.vue'),
}

export const OccupationTool = {
    path: '/occupation_tools',
    name: 'occupation_tools',
    component: () => import('@/views/Tools/OccupationToolPage.vue'),
}

export const EvaluationMeasureTools = {
    path: '/evaluation_measures_tools',
    name: 'evaluation_measures_tools',
    component: () => import('@/views/Tools/EvaluationMeasureTools.vue'),
}

export const EvaluationFileTools = {
    path: '/evaluation_files_tools',
    name: 'evaluation_files_tools',
    component: () => import('@/views/Tools/EvaluationFileTools.vue'),
    children: [
        {
            path: '/evaluation_files_tools/view',
            name: 'evaluation_files_tools.view',
            component: () => import('@/views/Evaluation/File/Form/EvaluationFileForm.vue'),
            props: {localViewAction: true,}
        },
    ]
}

export const ContratTemplateTool = {
    path: '/contrat_template_tools',
    name: 'contrat_template_tools',
    component: () => import('@/views/Tools/ContratTemplateToolPage.vue'),
}

export const ContratTool = {
    path: '/contrat_tools',
    name: 'contrat_tools',
    component: () => import('@/views/Tools/ContratToolPage.vue'),
}

export const CnasAgencyTool = {
    path: '/cnas_agency_tools',
    name: 'cnas_agency_tools',
    component: () => import('@/views/Tools/CnasAgencyToolPage.vue'),
}

export const DebtTool = {
    path: '/debt_tools',
    name: 'debt_tools',
    component: () => import('@/views/Tools/DebtToolPage.vue'),
}

export const WorkerTool = {
    path: '/worker_tools',
    name: 'worker_tools',
    component: () => import('@/views/Tools/WorkerToolPage.vue'),
}

export const PaySlipTool = {
    path: '/pay_slip_tools',
    name: 'pay_slip_tools',
    component: () => import('@/views/Tools/PaySlipToolPage.vue'),
}